import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, Home } from "lucide-react";
import SEO from "./SEO";

/**
 * Reusable breadcrumb component.
 * Emits:
 *   - visible breadcrumb UI (RTL-friendly)
 *   - BreadcrumbList JSON-LD via the SEO component's jsonLd prop
 *
 * Usage:
 *   <Breadcrumb items={[{label:"مناطق الخدمة", path:"/areas"}, {label:"المعادي", path:"/areas/المعادي"}]} />
 */
export default function Breadcrumb({ items = [], path = "" }) {
  const all = [
    { label: "الرئيسية", path: "/", icon: true },
    ...items,
  ];
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: all.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      item: `https://winchmohamedbahr.com${it.path}`,
    })),
  };
  return (
    <>
      <SEO jsonLd={jsonLd} path={path} title="" noindex />
      <nav aria-label="breadcrumb" style={{ marginBottom: "1rem", direction: "rtl" }}>
        <ol style={{ display: "flex", flexWrap: "wrap", listStyle: "none", padding: 0, margin: 0, fontSize: "0.9rem", color: "#666" }}>
          {all.map((it, i) => (
            <li key={i} style={{ display: "flex", alignItems: "center" }}>
              {i > 0 && <ChevronLeft size={14} style={{ margin: "0 0.4rem" }} />}
              {i < all.length - 1 ? (
                <Link to={it.path} style={{ color: "#0a2c61", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 4 }}>
                  {it.icon && <Home size={14} />}
                  {it.label}
                </Link>
              ) : (
                <span style={{ color: "#333", fontWeight: 600 }}>{it.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}
